import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  roomRate: {
    data: [],
    meta: {
      total: 0,
    },
  },
  mainRoomRate: [],
};

// TODO: fetch all the roomRate
export const fetchRoomRate = createAsyncThunk(
  "fetchRoomRate/roomRate",
  async ({ enqueueSnackbar, limit = 10, page = 0 }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`room-rates`, {
        params: {
          limit,
          page: page + 1,
        },
      });

      return {
        data: response.data.data,
        meta: {
          total: response.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create roomRates
export const createRoomRate = createAsyncThunk(
  "createRoomRate/roomRate",
  async (
    { data, enqueueSnackbar, handleClose, activeTab, setActiveTab },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.post(`room-rates`, data);

      thunkApi.dispatch(fetchRoomRate({ limit: 10, page: 0 }));
      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
        activeTab,
        setActiveTab,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update roomRates
export const updateRoomRate = createAsyncThunk(
  "updateRoomRate/roomRate",
  async ({ image, data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`room-rates/${id}`, data);

      thunkApi.dispatch(fetchRoomRate({ limit: 10, page: 0 }));
      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
        image,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete roomRates
export const deleteRoomRate = createAsyncThunk(
  "deleteRoomRate/roomRate",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`room-rates/${id}`);
      thunkApi.dispatch(fetchRoomRate({ limit: 10, page: 0 }));

      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const roomRatelice = createSlice({
  name: "roomRates",
  initialState,
  reducers: {
    resetLoadings: (state) => {
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
  extraReducers: (builder) => {
    // TODO: get roomRates
    builder.addCase(fetchRoomRate.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchRoomRate.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.roomRate = action.payload;
      state.mainRoomRate = state.roomRate?.data?.filter?.(
        (cat) => cat?.parent_id === null
      );
    });

    builder.addCase(fetchRoomRate.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: create roomRates
    builder.addCase(createRoomRate.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createRoomRate.fulfilled, (state, action) => {
      state.isLoading = false;
      state.roomRate.data = [action.payload.data, ...state.roomRate.data];
      state.roomRate.meta.total = state.roomRate.meta.total + 1;
      action.payload.enqueueSnackbar("RoomRates is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createRoomRate.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: update roomRates
    builder.addCase(updateRoomRate.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateRoomRate.fulfilled, (state, action) => {
      state.isLoading = false;
      if (!action.payload.image) {
        state.roomRate.data = state.roomRate.data.map((roomRates) => {
          if (roomRates.id === action.payload.data.id) {
            return action.payload.data;
          } else {
            return roomRates;
          }
        });
      }
      // action.payload.image &&  window.location.reload()
      action.payload.enqueueSnackbar("RoomRates is updated successfully.", {
        variant: "success",
      });

      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateRoomRate.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: delete roomRates
    builder.addCase(deleteRoomRate.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteRoomRate.fulfilled, (state, action) => {
      state.isLoading = false;
      state.roomRate.data = state.roomRate.data.filter(
        (roomRates) => roomRates.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("RoomRates is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteRoomRate.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });
  },
});

export default roomRatelice.reducer;

export const { resetLoadings } = roomRatelice.actions;
